import I18N from '@leverege/i18n'

import LayoutRoute from './LayoutRoute'

const { t, tIcon } = I18N.ns( 'ps.StationsRouteCreator' )

function processRelationship( molten, relationship, options ) {
  const { blueprint } = relationship

  if ( blueprint.type === 'station' ) {
    LayoutRoute.create( molten, {
      id : 'ps.stations.Analytics',
      relationship,
      layoutName : 'Analytics',
      icon : 'https://discount-tire-ui-assets.storage.googleapis.com/icon-analytics.png',
      layout : {
        sort : 'f.2',
      },
    } )
  }

  if ( blueprint.type === 'store' ) {
    LayoutRoute.create( molten, {
      id : 'ps.store.OperatingHours',
      relationship,
      layoutName : 'Operating Hours',
      icon : 'fa fa-fw fa-clock-o',
      layout : {
        sectionName : 'Store Management',
        sort : 'u.3',
      },
      matches : {
        client : 'ItemScreen',
        objectType : 'store',
        path : 'store',
        use : 'navBar',
      },
      linkPath : `${relationship.urlPath}/:storeId/OperatingHours`,
      isItem : true,
    } )

    LayoutRoute.create( molten, {
      id : 'ps.store.StoreTraffic',
      relationship,
      layoutName : t( 'storeTraffic' ),
      icon : tIcon( 'personIcon' ),
      layout : {
        sectionName : 'Customer Traffic',
        sort : 'd.1',
      },
      matches : {
        client : 'ItemScreen',
        objectType : 'store',
        path : 'store',
        use : 'navBar',
      },
      linkPath : `${relationship.urlPath}/:storeId/StoreTraffic`,
      isItem : true,
    } )

    LayoutRoute.create( molten, {
      id : 'ps.store.Alerts',
      relationship,
      layoutName : 'Alerts',
      icon : 'fa-solid fa-bell',
      layout : {
        sectionName : 'Store Management',
        sort : 'u.1',
      },
      matches : {
        client : 'ItemScreen',
        objectType : 'store',
        path : 'store',
        use : 'navBar',
      },
      linkPath : `${relationship.urlPath}/:storeId/Alerts`,
      isItem : true,
    } )
  }

  // if ( blueprint.type === 'room' ) {
  // LayoutRoute.create( molten, {
  //   id : 'ps.room.RoomOccupancy',
  //   relationship,
  //   layoutName : 'Room Occupancy',
  //   icon : 'fa-solid fa-dog',
  //   layout : {
  //     sectionName : 'Occupancy',
  //     sort : 'e.2',
  //   },
  //   matches : {
  //     client : 'ItemScreen',
  //     objectType : 'store',
  //     path : 'store',
  //     use : 'navBar',
  //   },
  //   linkPath : `${relationship.urlPath}/:storeId/RoomOccupancy`,
  //   isItem : true,
  // } )
  // }
}

export default {
  id : 'ps.stations.BlueprintRouteCreator',
  type : 'ps.stations.BlueprintRouteCreator',
  processRelationship,
}
